import React from "react";
import { useTranslation } from "react-i18next";
import { Skeleton } from "../skeleton/Skeleton";
import { CalendarView } from "../../features/calendar/models/CalendarView";

/**
 * Loading stand-in for the calendar grid, shaped like the view it replaces so
 * the layout doesn't jump when the range arrives.
 */
const CalendarSkeleton: React.FC<{ view: CalendarView }> = ({ view }) => {
  const { t } = useTranslation();
  const cells = view === "week" ? 7 : 35;

  return (
    <div
      role="status"
      aria-live="polite"
      aria-label={t("common.loading", "Loading…")}
      className={`with-border grid overflow-hidden rounded-2xl ${
        view === "week" ? "grid-cols-1 lg:grid-cols-7" : "grid-cols-7"
      }`}
    >
      {Array.from({ length: cells }, (_, index) => (
        <div
          key={index}
          className={`border-b border-grey-70 p-2 dark:border-grey-50 ${
            view === "week"
              ? "min-h-24 last:border-b-0 lg:min-h-96 lg:border-r lg:border-b-0 lg:last:border-r-0"
              : "min-h-24 lg:min-h-28"
          }`}
        >
          <Skeleton className="mb-2 h-5 w-10" />
          {index % 3 === 0 && <Skeleton className="h-8 w-full" />}
        </div>
      ))}
    </div>
  );
};

export default CalendarSkeleton;
